const languageLabels = new Map([
  ['zh', '中文'],
  ['cn', '中文'],
  ['en', '英语'],
  ['ja', '日语'],
  ['jp', '日语'],
  ['ko', '韩语'],
  ['fr', '法语'],
  ['es', '西班牙语'],
  ['it', '意大利语'],
  ['de', '德语'],
  ['tr', '土耳其语'],
  ['ru', '俄语'],
  ['pt', '葡萄牙语'],
  ['vi', '越南语'],
  ['id', '印尼语'],
  ['th', '泰语'],
  ['ms', '马来语'],
  ['ar', '阿拉伯语'],
  ['original', '原声'],
])

// 仅转换展示名称；选择值和接口请求继续使用原始语种代码。
export const formatReplayLanguage = (language, fallback = '—') => {
  const code = String(language || '').trim()
  if (!code) return fallback
  const base = code.toLowerCase().replace(/_/g, '-').split('-')[0]
  return languageLabels.get(base) || code.toUpperCase()
}

export function formatGenerationDuration(milliseconds) {
  if (milliseconds == null || milliseconds === '') return '—'
  const value = Number(milliseconds)
  if (!Number.isFinite(value) || value < 0) return '—'
  const seconds = Math.floor(value / 1000)
  return [Math.floor(seconds / 3600), Math.floor((seconds % 3600) / 60), seconds % 60]
    .map((part) => String(part).padStart(2, '0'))
    .join(':')
}

export function replayOutputLabel(output) {
  if (output.outputKind === 'MEETING_MATERIALS') return '会议资料基础版 · 静音'
  if (output.audioType === 'SILENT') return '会议画面与字幕 · 静音'
  if (output.audioType === 'ORIGINAL') return '原声版本'
  return formatReplayLanguage(output.language || output.languageCode, '翻译版')
}

// Only report recorded acceleration; missing warnings do not establish natural speech speed.
export function replayTtsSpeedAdjustment(output) {
  const warnings = Array.isArray(output?.qualityWarnings)
    ? output.qualityWarnings.filter((warning) => warning?.code === 'TTS_SPEED_ADJUSTED')
    : []
  if (!warnings.length) return null
  const tempos = warnings
    .map((warning) => Number(warning.details?.tempo))
    .filter((tempo) => Number.isFinite(tempo) && tempo > 1)
  const recorded = tempos.length ? `，已记录片段最高约 ${Math.max(...tempos).toFixed(2)}×` : ''
  return { detail: `部分翻译配音为对齐会议时间轴已加速${recorded}。` }
}
